import {Component, ElementRef, Input, OnDestroy, OnInit} from '@angular/core';
import {ClickOutsideService} from "../../shared-services/click-outside/click-outside.service";
import {Subscription} from "rxjs";
@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.scss'
})
export class DropdownComponent implements OnInit, OnDestroy {
  @Input() classes: string = ''
  isOpen = false;
  isAnimate = false;
  isToggle = false;

  private clickOutsideSubscription!: Subscription;

  constructor(private clickOutsideService: ClickOutsideService, private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.clickOutsideSubscription = this.clickOutsideService.clickOutside(this.elementRef.nativeElement)
      .subscribe(() => {
        if (this.isOpen) {
          this.close();
        }
      });
  }

  toggleDropdown(): void {
    if (this.isOpen) {
      this.close();
    } else {
      this.isOpen = true;
      this.isToggle = true;
      this.isAnimate = false;
    }
  }

  close(): void {
    this.isToggle = false;
    this.isAnimate = true;
    setTimeout(() => {
      this.isOpen = false;
      this.isAnimate = false;
    }, 250);
  }

  ngOnDestroy(): void {
    if (this.clickOutsideSubscription) {
      this.clickOutsideSubscription.unsubscribe();
    }
  }
}
